import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiResponse } from '../../models/common.model';
import { loadIndividualProducts, loadIndividualProductsFailure, loadIndividualProductsSuccess } from './individual-all-product.action';
import { CustomerService } from '../../services/customer.service';

@Injectable()
export class IndividualProductEffects {
  constructor(private actions$: Actions, private customerService: CustomerService) { }

  // Effect to load filtered products
  loadIndividualProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadIndividualProducts),
      switchMap((action: { categoryId?: string; subRegionId?: any; search?: any; page?: number; basedProduct?: string; isPopular?: boolean,
         orderBy?: string, loadTags? : boolean
      }) =>
        this.customerService.getMemberShopProductList({
          categoryId: action.categoryId,
          subRegionId: action.subRegionId,
          search: action.search,
          page: action.page,
          basedProduct: action?.basedProduct,
          isPopular: action?.isPopular,
          orderBy: action?.orderBy,
          loadTags: action?.loadTags
        }).pipe(
          map((response: ApiResponse) => {
            return loadIndividualProductsSuccess({ individualProducts: response.body });
          }),
          catchError((error) =>
            of(
              loadIndividualProductsFailure({
                error: {
                  message: error.message || 'An unknown error occurred',
                  statusCode: error.status || 500,
                },
              })
            )
          )
        )
      )
    )
  );
}
